<script setup lang="ts">
import type { Carousel } from "~/lib/caroussel";

defineProps<{ carousel: Carousel }>();
</script>

<template>
    <div class="flex justify-center gap-2 mt-4">
        <button
            v-for="(_, idx) in carousel.images"
            :key="idx"
            :class="carousel.isSelected(idx) ? 'bg-primary' : 'bg-gray-200'"
            class="w-3 h-3 rounded-full border"
            @click="carousel.selectImage(idx)"
        ></button>
    </div>
</template>
